import * as Yup from "yup";
import {
  CSV_FORMULA_LEADING_CHARS,
  MAX_SERIAL_LENGTH,
} from "../../pages/assetRegister/assetPositions/simpleAssetRegisterUpload/padSerialNumber";

export const yupPassword = (length = 8) => {
  return Yup.string()
    .required("Required")
    .min(length, `Password is too short - should be ${length} chars minimum.`)
    .matches(
      /[a-zA-Z0-9]/,
      "Password can only letters a-z, A-Z or numbers 0-9.",
    );
};
export const yupMatchPassword = (
  passwordFieldName = "password",
): Yup.StringSchema => {
  return Yup.string()
    .required("Confirmation of your new password is required")
    .oneOf([Yup.ref(passwordFieldName), null], "Must match your new password");
};

export const yupString = Yup.string();
export const yupRequiredString = Yup.string().required("Required");

// Mirrors the backend's SerialNumberStr in
// management-api/src/schema/asset/common.py — same rejection rules so
// users get immediate feedback rather than discovering a 422 after
// submit:
// * required, max 40 characters
// * no whitespace, ASCII quotes, Unicode smart-quotes or apostrophes
// * no leading =, +, -, @ (OWASP CSV-injection vectors — asset register
//   exports round-trip through Excel/LibreOffice)
//
// Note: the backend silently strips ASCII ' / U+2018 / U+2019 on its
// CSV ingestion paths (where LibreOffice tends to leak them); for
// direct keyboard entry we reject those characters outright because
// the user is in a position to fix them.
export const yupSerialNumber = (): Yup.StringSchema =>
  Yup.string()
    .required("Serial number is required")
    .max(
      MAX_SERIAL_LENGTH,
      `Serial number must be ${MAX_SERIAL_LENGTH} characters or fewer`,
    )
    .matches(
      /^[^\s'"‘’“”]+$/,
      "Serial number must not contain spaces, apostrophes, or quote characters",
    )
    .test(
      "no-csv-formula-leading",
      "Serial number must not start with =, +, -, or @",
      (value) => value == null || !CSV_FORMULA_LEADING_CHARS.includes(value[0]),
    );
